<template>
  <div class="fromList">
    <div class="right">
      <tree
        :treedata="treeData"
        @treesList="mytreeDataList"
          :keystree="keystree"
      />
    </div>
    <div class="leftN">
      <div class="storch">
        <!-- <div style="width:40%">
          <el-date-picker
            v-model="times"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div> -->
        <div  class="btnes">
        <!-- <el-button type="success" @click="addContent">查询</el-button> -->
        <el-button type="primary" icon="el-icon-edit" @click="lookDlg()">添加客户</el-button>
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="Delectloading"
        :element-loading-text="textContent"
        :row-class-name="tableRowClassName"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
      >
        <el-table-column prop="customername" label="客户名称"></el-table-column>
        <el-table-column prop="address" :show-overflow-tooltip="true" label="详细地址"></el-table-column>
        <el-table-column prop="longitude" label="经度"></el-table-column>
        <el-table-column prop="latitude" label="纬度"></el-table-column>
        <el-table-column prop="messagecount" label="可用短信数量"></el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="address" label="注册时间"></el-table-column> -->
        <el-table-column label="操作" align="center" fixed="right" width="280">
          <template slot-scope="{row}">
            <!-- <el-button size="mini" icon="el-icon-edit" type="primary" round @click="deiName(row)">详情</el-button> -->
            <el-button
              size="mini"
              @click="editFrom(row)"
              round
              icon="el-icon-edit"
              type="primary"
            >修改</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="deleData(row)"
              icon="el-icon-delete"
              round
            >删除</el-button>
             <!-- <el-button
              size="mini"
              type="danger"
              @click="lgoin(row)"
              icon="el-icon-delete"
              round
            >登录</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <page-helper :page-data="pageData" :total="total" :get-table-list="customerlist"></page-helper>

      <!-- 新增弹框 -->
      <el-dialog
        :close-on-click-modal="false"
        :title="title"
        :visible.sync="dialogVisible"
        :modal="false"
        width="40%"
        :before-close="handleClose"
      >
        <add
          :hidechile="hidechile"
          :is-add="isAdd"
          :rule-form="ruleForm"
          :customerlist="customerlist"
          ref="AddFrom"
        />
      </el-dialog>
    </div>
  </div>
</template>
<script>
//
import {
  treeinfo,
  customerlist,
  dealerDelete,
  customerinfo,
  LonginKH,
  getdatandexTab
} from "@/network/index";
import { setTimeout } from "timers";
import PageHelper from "@/components/common/PageHelper";
import tree from "@/components/common/tree";
import add from "./components/add";
import {mapState} from 'vuex'
export default {
  components: {
    PageHelper,
    tree,
    add
  },
  data() {
    return {
      title:'添加客户',
        Delectloading: false, //加载图表
      textContent: "正在努力加载中...", //加载提示文字
      ruleForm: {
        dealer_uuid: "",
        customername: "",
        address: "",
        longitude: "",
        latitude: "",
        regdate: "", //注册日期
        certificates: "", //组织证件
        coverphoto: "", //组织宣传封面
        flatpicture: "", //组织平面图片
        remark: "" //备注
      },
      isAdd: true,
      times: "",
      dialogVisible: false,
      tableData: [],
      treeData: [],
      dealer_uuid: "",
      pageData: {
        pagenum: 1, //页码  pagenum  2
        pagesize: 30 //数据   pagesize几条数据
      },
      total: null,
      keystree:[]
    };
  },
  mounted() {
    this.customerlist();
    this.treeinfo();
    this.getdatandexTab()
  },
  computed:{
    ...mapState(['userBox'])
  },
  methods: {
    // 打开默认值
  async getdatandexTab(){
       let pagenum = this.pagenum
      let pagesize = this.pagesize
        const {code,data} = await getdatandexTab(pagenum,pagesize)
         let lengthInfo =  data.default.length - 1
      this.keystree.push(data.default[lengthInfo].uuid)

      this.total = Number(data.pagelist[0].allrow);
       if (code) {
        this.tableData = data.list; //拿去数据
        // this.total = Number( data.allpage[0].allrow)
        this.Delectloading = false;
      } else {
        this.Delectloading = false;
      }
    },
    //登录
    async lgoin(e){
        window.open('http://39.103.154.86:9001/home')
       let optname = this.userBox.optname
       let optpassword = this.userBox.optpassword
       let clienttype = 1
       let logintype = 0
       let login_uuid = e.uuid
        const {code,data} = await LonginKH(optname,optpassword,clienttype,logintype,login_uuid) 
        console.log(data);
        if(code){
           const { appid,roletype } = data;
             sessionStorage.setItem("token", appid); //缓存taoken
   
        }
        
    },
        // 搜索功能
    serchBten(e){
      this.flyTay = true
      this.treeinfo(e)
    },
    // 斑马线
    tableRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    //数结构
    async treeinfo(search) {
      this.Delectloading = true;
      let levelid = this.$store.state.path;
      const { code, data, msg } = await treeinfo(levelid,search);
      if (code) {
        this.Delectloading = false;
        this.treeData = data;
      }
    },
    mytreeDataList(e) {
      this.ruleForm.dealer_uuid = e;
      this.dealer_uuid = e;
      this.customerlist();
    },
    // 列表数据
    async customerlist() {
      this.Delectloading = true;
      let pagenum = this.pageData.pagenum; //页码
      let pagesize = this.pageData.pagesize; //多少条数据
      let { code, data, msg } = await customerlist(
        this.ruleForm.dealer_uuid,
        pagenum,
        pagesize
      );
      this.total = Number(data.pagelist[0].allrow);
      if (code) {
        this.tableData = data.list;
        this.Delectloading = false;
      } else {
        this.$message.error(msg);
      }
    },
    // 隐藏子组件的弹框
    hidechile() {
      this.dialogVisible = false;
      this.ruleForm = {
        dealer_uuid: this.dealer_uuid,
        customername: "",
        address: "",
        longitude: "",
        latitude: "",
        regdate: "", //注册日期
        certificates: "", //组织证件
        coverphoto: "", //组织宣传封面
        flatpicture: "", //组织平面图片
        remark: "" //备注
      };
      this.$refs.AddFrom.fileList = [];
      this.$refs.AddFrom.MfileList = []; //组织宣传封
      this.$refs.AddFrom.ZfileList = [];
    },
    //查询
    addContent() {},
    //添加
    lookDlg() {
      if (this.dealer_uuid == "") {
        this.$message.error("请选择所属经销商");
      } else {
        this.title = '添加客户'
        this.isAdd = true;
        this.dialogVisible = true;
      }
    },
    // 详情
    async deiName(e) {
      console.log(e);
      const { code, msg, data } = await customerinfo(e.uuid);
      console.log(data);
      data.forEach(item => {
        this.ruleForm = item;
      });
      this.isAdd = false;
      this.dialogVisible = true;
    },
    //   修改
    editFrom(e) {
      this.title = '修改客户'
      this.ruleForm = e;
      this.isAdd = true;
      this.dialogVisible = true;
    },
    //  删除
    deleData(e) {
      let tablename = "tb_customer";
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
         closeOnClickModal:false,
        type: "warning"
      })
        .then(async () => {
          const { code, msg } = await dealerDelete(e.uuid, tablename);
          if (code) {
            this.customerlist();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          }else{
            this.$message.error(msg)
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 清空for表单
    handleClose() {
      this.dialogVisible = false;
      this.ruleForm = {};
      this.$refs.AddFrom.fileList = [];
      this.$refs.AddFrom.MfileList = []; //组织宣传封
      this.$refs.AddFrom.ZfileList = [];
    }
  }
};
</script>
<style scoped>
.fromList {
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.right {
  width: 257px;
  height: 100%;
  overflow: auto;
}
.leftN {
  /* flex: 80%; */
  width: 80%;
  padding: 0 10px;
  height: 100%;
  overflow: auto;
}
.storch {
  display: flex;
  padding-bottom: 15px;
}
.storch button {
  margin: 0 10px;
}
</style>
